/* eslint-disable no-unused-vars */


import React from 'react';
function DisplaySettingsContent() {
    return <div>Display Settings Content</div>;
}
function ConsumableSettingsContent() {
    return <div>Consumable Settings Content</div>;
}

function AnalysisSettingsContent() {
    return <div>Analysis Settings</div>;
}

function AnalysisResultSettingsContent() {
    return <div>Analysis Result Settings</div>;
}

function ActionSettingsContent() {
    return <div>Action Settings</div>;
}
export const tabsData = [

    {
        label: 'Display Settings',
        content: 'DisplaySettingsContent'
    },
    {
        label: 'Info/Consumable',
        content: 'ConsumableSettingsContent'
    },
    {
        label: 'Analysis',
        content: 'AnalysisSettingsContent'
    },
    {
        label: 'Analysis Results',
        content: 'AnalysisResultSettingsContent'
    },
    {
        label: 'Actions',
        content: 'ActionSettingsContent'
    }

];